function popupRules(app) {
  return {
    buildingName: [
      {
        max: 50,
        message: app.$t('message.common.validation.max', {
          field: app.$t('label.popup.system.building.label.buildingName'),
          length: 50
        }),
        trigger: 'blur'
      }
    ],
    buildingExId: [
      {
        max: 20,
        trigger: 'blur',
        message: app.$t('message.common.validation.size', {
          field: app.$t('label.popup.system.building.label.buildingExId'),
          length: 20
        })
      },
      {
        pattern: /^[A-Za-z0-9]+$/,
        trigger: 'blur',
        message: app.$t('message.common.validation.type', {
          field: app.$t('label.popup.system.building.label.buildingExId'),
          type: '半角英数字'
        })
      }
    ],
  }
}

export default {
  popupRules: popupRules
}
